import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'servicedesk-insight-status-picker.error-flag-title',
		defaultMessage: 'We couldn’t load your statuses',
		description: 'Error title when failing to load list of statuses',
	},
	errorFlagDescription: {
		id: 'servicedesk-insight-status-picker.error-flag-description',
		defaultMessage: 'Please check your network and try again',
		description: 'Error message when failing to load list of statuses',
	},
	searchPlaceholder: {
		id: 'servicedesk-insight-status-picker.search-placeholder',
		defaultMessage: 'Filter statuses…',
		description: 'Placeholder message when the status search input is empty',
	},
	groupHeader: {
		id: 'servicedesk-insight-status-picker.group-header',
		defaultMessage: 'Showing {numberOfStatuses} of {totalStatuses} statuses',
		description: 'The number of statuses filtered, out of the total number of statuses',
	},
});
